function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var borderRadius = {
  "ds-border-radius-circle": "50%",
  "ds-border-radius-small": "0.25rem",
  "ds-border-radius-medium": "0.5rem",
  "ds-border-radius-large": "1rem",
  "ds-border-radius-big": "1.25rem"
};
var borderWidth = {
  "ds-border-width-thin": "1px",
  "ds-border-width-default": "2px"
};
var caution = "#ffb7b5";
var cautionRgb = "255, 183, 181";
var highlightGreen = "#baffee";
var highlightGreenRgb = "186, 255, 238";
var highlightPink = "#ffb5ef";
var highlightPinkRgb = "255, 181, 239";
var primary = "#006ed8";
var primaryRgb = "0, 110, 216";
var primaryPressed = "#0986ff";
var primaryPressedRgb = "9, 134, 255";
var secondary = "#cbddf2";
var secondaryRgb = "203, 221, 242";
var white = "#fff";
var whiteRgb = "255, 255, 255";
var black = "#000";
var blackRgb = "0, 0, 0";
var panel = "#435880";
var panelRgb = "67, 88, 128";
var onPanel = "#596D92";
var onPanelRgb = "rgb(89,109,146)";
var neonGreen = "#cdfff3";
var neonGreenRgb = "205, 255, 243";
var neonPink = "#ffeeff";
var neonPinkRgb = "255, 238, 255";
var neonBlue = "#5df0fa";
var neonBlueRgb = "93, 240, 250";
var core = {
  "ds-colour-caution": caution,
  "ds-colour-caution-rgb": cautionRgb,
  "ds-colour-highlight-green": highlightGreen,
  "ds-colour-highlight-green-rgb": highlightGreenRgb,
  "ds-colour-highlight-green-alpha-33": "rgba(".concat(highlightGreenRgb, ", 0.33)"),
  "ds-colour-highlight-pink": highlightPink,
  "ds-colour-highlight-pink-rgb": highlightPinkRgb,
  "ds-colour-neon-pink": neonPink,
  "ds-colour-neon-pink-rgb": neonPinkRgb,
  "ds-colour-neon-green": neonGreen,
  "ds-colour-neon-green-rgb": neonGreenRgb,
  "ds-colour-neon-blue": neonBlue,
  "ds-colour-neon-blue-rgb": neonBlueRgb,
  "ds-colour-panel-dark": "#364665",
  "ds-colour-panel-dark-rgb": "54, 70, 101",
  "ds-colour-panel": panel,
  "ds-colour-panel-rgb": panelRgb,
  "ds-colour-on-panel": onPanel,
  "ds-colour-on-panel-rgb": onPanelRgb,
  "ds-colour-panel-elevated": "#0b7190",
  "ds-colour-panel-elevated-rgb": "11, 113, 144",
  "ds-colour-primary": primary,
  "ds-colour-primary-rgb": primaryRgb,
  "ds-colour-secondary": secondary,
  "ds-colour-secondary-rgb": secondaryRgb,
  "ds-colour-secondary-alpha-33": "rgba(".concat(secondaryRgb, ", 0.33)"),
  "ds-colour-secondary-alpha-8": "rgba(".concat(secondaryRgb, ", 0.08)"),
  "ds-colour-secondary-shade-34": "#7184a6",
  "ds-colour-secondary-shade-34-rgb": "113, 132, 166",
  "ds-colour-white": white,
  "ds-colour-white-rgb": whiteRgb,
  "ds-colour-white-alpha-12": "rgba(".concat(whiteRgb, ", 0.12)"),
  "ds-colour-black": black,
  "ds-colour-black-rgb": blackRgb,
  "ds-colour-black-alpha-32": "rgba(".concat(blackRgb, ", 0.32)"),
  "ds-colour-transparent": "transparent"
};
var defaults = {
  "ds-colour-button-primary": primary,
  "ds-colour-button-primary-disabled": "rgba(".concat(secondaryRgb, ", 0.33)"),
  "ds-colour-button-primary-pressed": primaryPressed,
  "ds-colour-button-secondary-pressed": "rgba(".concat(primaryPressedRgb, ", 0.33)"),
  "ds-colour-button-tertiary-pressed": "rgba(".concat(primaryPressedRgb, ", 0.33)")
};
var colour = __spreadValues(__spreadValues({}, core), defaults);
var fontFamily = {
  "ds-font-family-ds-averta": "DSAverta, Helvetica Neue, Helvetica, Arial, sans-serif"
};
var fontSize = {
  "ds-font-size-micro": "0.625rem",
  "ds-font-size-tiny": "0.75rem",
  "ds-font-size-mini": "0.875rem",
  "ds-font-size-small": "1rem",
  "ds-font-size-adequate": "1.125rem",
  "ds-font-size-medium": "1.25rem",
  "ds-font-size-large": "1.5rem",
  "ds-font-size-big": "2.25rem",
  "ds-font-size-huge": "2.5rem",
  "ds-font-size-massive": "2.75rem",
  "ds-font-size-jumbo": "3.5rem"
};
var fontWeight = {
  "ds-font-weight-extra-thin": 100,
  "ds-font-weight-thin": 200,
  "ds-font-weight-light": 300,
  "ds-font-weight-regular": 400,
  "ds-font-weight-medium": 500,
  "ds-font-weight-semi-bold": 600,
  "ds-font-weight-bold": 700,
  "ds-font-weight-extra-bold": 800,
  "ds-font-weight-black": 900
};
var lineHeight = {
  "ds-line-height-small": "1rem",
  "ds-line-height-adequate": "1.125rem",
  "ds-line-height-medium": "1.25rem",
  "ds-line-height-generous": "1.375rem",
  "ds-line-height-large": "1.5rem",
  "ds-line-height-great": "1.75rem",
  "ds-line-height-big": "2rem",
  "ds-line-height-huge": "2.5rem",
  "ds-line-height-massive": "2.75rem",
  "ds-line-height-jumbo": "3.25rem",
  "ds-line-height-gigantic": "4rem",
  "ds-line-height-reset": "1",
  "ds-line-height-text": "1.5",
  "ds-line-height-heading": "1.2"
};
var small = 375;
var phablet = 512;
var medium = 768;
var large = 1024;
var huge = 1408;
var mediaQuery = {
  "ds-mq-small": "(min-width: ".concat(small, "px)"),
  "ds-mq-phablet": "(min-width: ".concat(phablet, "px)"),
  "ds-mq-medium": "(min-width: ".concat(medium, "px)"),
  "ds-mq-large": "(min-width: ".concat(large, "px)"),
  "ds-mq-huge": "(min-width: ".concat(huge, "px)")
};
var shadow = {
  "ds-shadow-neon-green": "0px 0px 50px rgba(40, 255, 202, 0.2), 0px 0px 10px rgba(84, 255, 213, 0.5), inset 0px 0px 2px #00a980",
  "ds-shadow-neon-pink": "0px 0px 4px rgba(255, 111, 223, 0.5), 0px 0px 4px rgba(255, 103, 222, 0.04), 0px 0px 20px rgba(255, 103, 222, 0.5), inset 0px 0px 1px #ee3edf",
  "ds-shadow-dark": "0px 3px 6px rgba(0, 0, 0, 0.039), 0px 7px 24px rgba(0, 0, 0, 0.19)"
};
var spacing = {
  "ds-spacing-none": "0rem",
  "ds-spacing-nano": "0.125rem",
  "ds-spacing-micro": "0.25rem",
  "ds-spacing-tiny": "0.5rem",
  "ds-spacing-small": "0.75rem",
  "ds-spacing-medium": "1rem",
  "ds-spacing-generous": "1.25rem",
  "ds-spacing-large": "1.5rem",
  "ds-spacing-big": "2rem",
  "ds-spacing-huge": "3rem",
  "ds-spacing-super": "4rem",
  "ds-spacing-jumbo": "8rem"
};
var timing = {
  "ds-timing-fast": "250ms",
  "ds-timing-normal": "500ms",
  "ds-timing-slow": "1000ms",
  "ds-timing-easing-in": "cubic-bezier(0.4, 0, 1, 1)"
};
var zIndex = {
  "ds-zindex-dive": -200,
  "ds-zindex-default": 1,
  "ds-zindex-levitate": 2,
  "ds-zindex-rise": 200,
  "ds-zindex-sky": 400,
  "ds-zindex-top": 600
};
var gradient = {
  "ds-gradient-high-performance": "linear-gradient(270.02deg, #76ffce 4.12%, #ffa6eb 100%)",
  "ds-gradient-low-performance": "linear-gradient(270.02deg, #e6aa6c 5.66%, #ff8b8b 100%)",
  "ds-gradient-background-bottom": "linear-gradient(161.6deg, #23358c 17.72%, #553e59 104.69%)",
  "ds-gradient-background-top": "radial-gradient(rgba(67, 213, 239, 0.5) 0%, rgba(47, 199, 208, 0) 60%, transparent 40%)",
  "ds-gradient-background": "linear-gradient(161.6deg, #20588B 17.72%, #463E76 104.69%)",
  "ds-gradient-tooltip": "linear-gradient(140deg, rgb(54, 138, 170) 10%, rgb(57, 80, 170) 100%)"
};
export { borderRadius, borderWidth, colour, fontFamily, fontSize, fontWeight, gradient, lineHeight, mediaQuery, shadow, spacing, timing, zIndex };